import { createContext, useMemo } from 'react';
import {
    useGetDesignCategoriesQuery,
    useGetDesignsByCategoryQuery,
} from '../store/features/customProductApi';
import { DesignCategory, DesignItem, DesignResult } from '../models/pulsePrint';

export type DesignByCategoriesContextType = {
    designCategoriesData: DesignCategory[] | undefined;
    designByCategoriesData: DesignItem[] | undefined;
};

export const DesignByCategoriesContext =
    createContext<DesignByCategoriesContextType>({
        designCategoriesData: [],
        designByCategoriesData: undefined,
    });

export const DesignByCategoriesProvider = ({ children }: any) => {
    // C'est l'id de la catégorie "Animaux" qui est par défaut la première affichée
    const defaultId = 180;
    const { data: designCategoriesData } = useGetDesignCategoriesQuery();
    const { data: designByCategoriesData } = useGetDesignsByCategoryQuery({
        categoryId: designCategoriesData
            ? designCategoriesData[0].id
            : defaultId,
    });
    const designCategoriesAndByCategories = useMemo(
        () => ({
            designCategoriesData,
            designByCategoriesData,
        }),
        [designCategoriesData, designByCategoriesData]
    );

    return (
        <DesignByCategoriesContext.Provider
            value={designCategoriesAndByCategories}
        >
            {children}
        </DesignByCategoriesContext.Provider>
    );
};
